import { FilledIconButton } from "../FilledIconButton"

export function MoreButton(props) {

    const {
        color,
        disabled = false,
        size,
        icon,
        onClick,
    } = props

    const Icon = icon

    return <FilledIconButton id="linear-edit-button" color={color} size={size} onClick={onClick} disabled={disabled}>
        <Icon fontSize={size} />
    </FilledIconButton>
}